module.exports = __webpack_public_path__ + "media/images/category/art-c87a8e348739ece46abe79fb2e889b52.jpg";